import { render, staticRenderFns } from "./codepay.vue?vue&type=template&id=2b01e4f9&"
import script from "./codepay.vue?vue&type=script&lang=js&"
export * from "./codepay.vue?vue&type=script&lang=js&"
import style0 from "./codepay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports